<template>
	<div class="thank-you-page-wrapper">
		<v-layout v-if="showLoader" justify-center>
			<v-progress-circular indeterminate color="#ffffff" :size="45" style="margin-bottom: 17px" />
		</v-layout>
		<v-layout column v-else-if="!foreignOrderNumber" class="order-info-box">
			<div class="order-error-class">{{ $t("shopComponents.gt3.pendingOrder.pendingOrder.pendingOrderOnlinePosFailedError") }}</div>
			<br/>
			<div class="order-error-class order-number">{{ order.orderNumber }}</div>
		</v-layout>
		<template v-else>
			<v-layout class="thank-you-order-success">
				<div class="thank-you-message">{{ $t("shopComponents.gt3.payAtCounter.thankYouForOrder") }}</div>
				<div class="thank-you-order-number">{{ $t("shopComponents.gt3.payAtCounter.yourOrderNumber") }} </div>
			</v-layout>
			<div class="thank-you-foreign-order-number">{{foreignOrderNumber}} </div>
		</template>
		<v-btn
			class="go-to-home-page-btn"
			flat
			clickable
			@click="goToHomePage"
			:disabled="showLoader"
		>
			{{ $t("shopComponents.gt3.payAtCounter.goToHomeScreen") }}
		</v-btn>
	</div>
</template>

<script>

import OrdersProvider from "../../../../providers/OrdersProvider";
import mutationTypesBM100 from "../../../../store/globalTemplateSpecificModules/storeModulesBM100/mutationTypesBM100";
import {mapGetters} from "vuex";
import * as actions from "../../../../store/mutation-types";
import OrderHelperObject from "../../../../domains2/orders/OrderHelperObject";
import EmployeeTokenProvider from "../../../../providers/EmployeeTokenProvider";
import appConfig from "../../../../appconfig";
import kioskIdleTimeoutMixin from "../../../../mixins/kioskIdleTimeout.mixin";
import * as mutationTypes from "../../../../store/mutation-types";
const tenantConfig = appConfig.tenantConfig;

export default {
	name: "PayAtCounterThankYou",
	data() {
		return {
			order: null,
			orderNumberInterval: null,
			showLoader: true,
			hasRequestedPayAtCounterPrint: false
		};
	},
	mixins: [kioskIdleTimeoutMixin],
	async created() {
		const self = this;
		clearInterval(this.interval);
		clearTimeout(this.time);
		self.order = await this.getOrder();
		self.orderNumberInterval = setInterval(function () {
			OrdersProvider.findForeignOrderNumber({
				queryData: {
					orderNumber: self.order.orderNumber,
					tenantId: tenantConfig.tenantId,
					getAllIds: true
				}
			}).then(result => {
				const foreignOrderNumberData = self.extractForeignOrderNumberData(result.data);
				const _foreignOrderNumber = OrderHelperObject.getForeignOrderNumberBasedOnFt(
					self.featureToggles.displayNewForeignOrderNumber,
					foreignOrderNumberData.foreignOrderNumber,
					foreignOrderNumberData.shortForeignOrderNumber
				);
				if (_foreignOrderNumber) {
					self.$store.commit(mutationTypesBM100.SET_FOREIGN_ORDER_NUMBER, _foreignOrderNumber);
					self.$store.commit(mutationTypesBM100.SET_ORIGINAL_FOREIGN_ORDER_NUMBER, foreignOrderNumberData.foreignOrderNumber);
					self.requestPayAtCounterReceiptPrint(foreignOrderNumberData);
					self.showLoader = false;
					clearInterval(self.orderNumberInterval);
				}
				EmployeeTokenProvider.updateEmployeeDiscountToken("use");
			}).catch(() => {
				self.showLoader = false;
				clearInterval(self.orderNumberInterval);
			});
			self.resetTimer();
			self.idleTimer();
		}, 5000);
	},
	computed: {
		...mapGetters(["pendingOrder", "cartOrderId", "foreignOrderNumber", "featureToggles", "lastLocale"])
	},
	methods: {
		extractForeignOrderNumberData(rawData) {
			if (typeof rawData === "string") {
				return {
					foreignOrderNumber: rawData,
					shortForeignOrderNumber: rawData,
					kioskForeignOrderNumber: rawData
				};
			}

			return rawData || {};
		},
		requestPayAtCounterReceiptPrint(foreignOrderNumberData) {
			const orderId = (this.order || {}).id;
			if (
				this.hasRequestedPayAtCounterPrint ||
				!orderId ||
				!window.parent ||
				!window.parent.postMessage
			) {
				return;
			}

			window.parent.postMessage({
				type: "PRINT_PAY_AT_COUNTER_RECEIPT",
				payload: {
					orderId,
					orderNumber: (this.order || {}).orderNumber,
					languageCode: this.lastLocale,
					...foreignOrderNumberData,
					receiptType: "pay-at-counter-short-receipt"
				}
			}, "*");

			this.hasRequestedPayAtCounterPrint = true;
		},
		goToHomePage() {
			this.$store.commit(mutationTypesBM100.SET_PENDING_ORDER, null);
			this.$store.commit(mutationTypesBM100.SET_FOREIGN_ORDER_NUMBER, null);
			this.$store.commit(actions.SET_CART_ORDER_ID,null);
			this.$store.dispatch(mutationTypes.CART_EMPTY_ALL);
			this.$router.push({ path: "/" });
		},
		async getOrder() {
			try {
				if(this.pendingOrder) {
					return this.pendingOrder;
				}
				if (this.cartOrderId) {
					const order = await OrdersProvider.findOne(this.cartOrderId);
					return order.data;
				}
			} catch (e) {
				return {};
			}
		}
	},
	beforeDestroy () {
		if(this.orderNumberInterval) {
			clearInterval(this.orderNumberInterval);
		}
		clearInterval(this.interval);
		clearTimeout(this.time);
	}
};
</script>

<style scoped lang="scss">
.thank-you-page-wrapper {
	height: 100vh;
	color: #FFFFFF;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 100px;
	justify-content: space-between;
	.thank-you-order-success {
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 30px;
		flex: 0 1 auto;
	}
	.thank-you-foreign-order-number {
		font-size: 100px;
		font-weight: bold;
		line-height: 1.2;
	}
	.order-info-box {
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 30px;
		text-align: center;
		.order-error-class.order-number {
			font-size: 50px;
			font-weight: bold;
		}
	}
}
.v-btn.go-to-home-page-btn {
	background-color: #218C74 !important;
	border: 2px solid #218C74;
	color: #FFFFFF;
	margin: 0;
	z-index: 100;
	height: 60px;
	width: auto !important;
	padding: 0 50px;
	min-width: 500px;
	&.v-btn--disabled {
		background-color: #218C74 !important;
	}
}
</style>
